(() => {
  if (window.__AFX_RESERVE_TIMER_INIT__) return;
  window.__AFX_RESERVE_TIMER_INIT__ = true;

  const KEY = "afx_cart_reserve_timer_end_v1";

  const pad2 = (n) => String(n).padStart(2, "0");

  const formatMMSS = (totalSeconds) => {
    const m = Math.floor(totalSeconds / 60);
    const s = totalSeconds % 60;
    return `${pad2(m)}:${pad2(s)}`;
  };

  const getOrCreateEnd = (durationSec) => {
    const now = Date.now();
    const raw = sessionStorage.getItem(KEY);

    // Si existe y es válido, úsalo
    if (raw) {
      const end = Number(raw);
      if (!Number.isNaN(end) && end > 0) {
        // si ya pasó, reinicia
        if (now >= end) {
          const next = now + durationSec * 1000;
          sessionStorage.setItem(KEY, String(next));
          return next;
        }
        return end;
      }
    }

    // Si no existe, crea fin nuevo
    const end = now + durationSec * 1000;
    sessionStorage.setItem(KEY, String(end));
    return end;
  };

  const tick = (el) => {
    const durationSec = Number(el.getAttribute("data-duration") || "890");
    const timeEl = el.querySelector("[data-afx-time]");
    if (!timeEl) return;

    let end = getOrCreateEnd(durationSec);

    const update = () => {
      const now = Date.now();
      let remaining = Math.ceil((end - now) / 1000);

      if (remaining <= 0) {
        // Reinicia al llegar a 0
        end = now + durationSec * 1000;
        sessionStorage.setItem(KEY, String(end));
        remaining = durationSec;
      }

      timeEl.textContent = formatMMSS(remaining);
    };

    update();

    // Evita duplicar intervalos si el drawer se re-renderiza
    if (el.__afxInterval) clearInterval(el.__afxInterval);
    el.__afxInterval = setInterval(update, 1000);
  };

  const initAll = (root = document) => {
    const nodes = root.querySelectorAll("[data-afx-reserve-timer]");
    nodes.forEach((el) => tick(el));
  };

  // 1) Init inicial
  initAll();

  // 2) Como tu cart se re-renderiza (xo-cart-will-change), observamos DOM
  const mo = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.addedNodes && m.addedNodes.length) {
        m.addedNodes.forEach((n) => {
          if (n.nodeType !== 1) return;
          if (n.matches && n.matches("[data-afx-reserve-timer]")) tick(n);
          if (n.querySelectorAll) initAll(n);
        });
      }
    }
  });

  mo.observe(document.documentElement, { childList: true, subtree: true });

  // 3) Si tu theme dispara eventos, también re-init (por si acaso)
  document.addEventListener("cart:updated", () => initAll());
  document.addEventListener("xo:cart:updated", () => initAll());
})();